import React, { useState, useEffect } from "react";
import { Input, Button, Form } from 'antd';
import { SearchOutlined } from "@ant-design/icons";
import { gqlBuilderWhere, helperFunc } from "utils";
import GraphicStandForms from '../forms';
import Icons from 'components/icons';
import { DrawerStandart, Localize } from "components/service";
import { DEFAULT_FILTER_FIELDS } from '../graphic-stand-const';

const { Search } = Input;

const GraphicStandTableFilter = ({
    graphicPacking,
    setSearchText,
    searchText,
    setFilters = false,
    filters,
    graphicStandsFilters,
    setResetSorting = () => { },
    objOrderBy,
    excludeFields = [],
    filterFields = DEFAULT_FILTER_FIELDS,
    searchPlaceholder = "SEARCH.Input_Placeholder_GraphicStands",
    filterTable = 'table-graphic-stands',
}) => {
    const [ form ] = Form.useForm();
    const [ filterList, setFilterList ] = useState({});
    const [ count, setCount ] = useState();

    const filterCount = helperFunc.countFilterList(count);

    /*eslint-disable */
    useEffect(() => {
        if (filters)
        {
            // Handle different localStorage key patterns
            if (graphicPacking?.id) {
                localStorage.setItem(`graphicStandsFilters-${ filterTable }_graphicPackingID-${ graphicPacking.id }`, JSON.stringify({ ...graphicStandsFilters, ...filterList }));
            } else {
                localStorage.setItem(`graphicWarehouseFilters-${ filterTable }`, JSON.stringify({ ...graphicStandsFilters, ...filterList }));
            }
        } else
        {
            const fieldsToReset = filterFields.filter(field => !excludeFields.includes(field));
            form.resetFields(fieldsToReset);
        }

        if (searchText)
        {
            // Handle different localStorage key patterns
            if (graphicPacking?.id) {
                localStorage.setItem(`graphicStandsSearch-${ filterTable }_graphicPackingID-${ graphicPacking.id }`, JSON.stringify(searchText));
            } else {
                localStorage.setItem(`graphicWarehouseSearch-${ filterTable }`, JSON.stringify(searchText));
            }
        } else
        {
            if (graphicPacking?.id) {
                localStorage.removeItem(`graphicStandsSearch-${ filterTable }_graphicPackingID-${ graphicPacking.id }`);
            } else {
                localStorage.removeItem(`graphicWarehouseSearch-${ filterTable }`);
            }
            form.resetFields([ 'search' ]);
        }
    }, [ filters, searchText ]);

    useEffect(() => {
        if (graphicStandsFilters)
        {
            setFilters(gqlBuilderWhere(graphicStandsFilters));
            setCount(graphicStandsFilters);
        }
    }, []);
    /*eslint-enable */

    return (
        <Form
            key="filters-form"
            className="clear-css-prop table-filter-form"
            layout="vertical"
            form={ form }>

            <Form.Item
                initialValue={ searchText }
                name="search">

                <Search
                    className="filter-search"
                    prefix={ <SearchOutlined /> }
                    placeholder={ Localize({ children: searchPlaceholder }).props.children }
                    onChange={ (e) => setSearchText(e.target.value) }
                />

            </Form.Item>

            <DrawerStandart
                width="287"
                extraClass={ 'modal-form filters' }
                modalButton={
                    <Button>
                        <Icons.Filter />
                        <span><Localize>FORMS.Button_Text_ApplyFilters</Localize></span>
                        { filterCount && <span className="filter-count">{ filterCount }</span> }
                    </Button>
                }
            >
                <strong className="modal-title">
                    <Localize>FORMS.Title_Text_Filters</Localize>
                </strong>

                <GraphicStandForms.Filter
                    graphicPacking={ graphicPacking }
                    setCount={ setCount }
                    setFilters={ setFilters }
                    setFilterList={ setFilterList }
                    filterList={ filterList }
                    gqlBuilderWhere={ gqlBuilderWhere }
                    graphicStandsFilters={ graphicStandsFilters }
                    form={ form }
                    excludeFields={ excludeFields }
                    filterFields={ filterFields }
                    filterTable={ filterTable }
                />

            </DrawerStandart>

            <Button
                type="link"
                onClick={ () => {
                    setFilterList({});
                    setCount({});
                    setFilters(gqlBuilderWhere({}));
                    setSearchText('');
                    setResetSorting(objOrderBy);

                    // Handle different localStorage key patterns
                    if (graphicPacking?.id) {
                        // For graphic packing pages
                        localStorage.removeItem(`graphicStandsFilters-${ filterTable }_graphicPackingID-${ graphicPacking.id }`);
                        localStorage.removeItem(`graphicStandsSorting-${ filterTable }_graphicPackingID-${ graphicPacking.id }`);
                        localStorage.removeItem(`graphicStandsSearch-${ filterTable }_graphicPackingID-${ graphicPacking.id }`);
                    } else {
                        // For warehouse page and other standalone pages
                        localStorage.removeItem(`graphicWarehouseFilters-${ filterTable }`);
                        localStorage.removeItem(`graphicWarehouseSorting-${ filterTable }`);
                        localStorage.removeItem(`graphicWarehouseSearch-${ filterTable }`);
                    }
                } }
            >
                <span><Localize>FORMS.Button_Text_ResetFilters</Localize></span>
            </Button>
        </Form>
    );
};

export default GraphicStandTableFilter;
